"use client";

import { useEffect, useState } from "react";

/**
 * Long enough that a handle or link being typed is looked up once, when the
 * typing stops, rather than once per letter. Every lookup is a request to
 * someone else's site from our servers, and they ration those.
 */
const LOOKUP_DEBOUNCE_MS = 600;

export function useSettledValue(value: string): string {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), LOOKUP_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [value]);
  return settled;
}
